import { ChangeEvent, ReactNode } from 'react'

import { BaseCheckbox } from '../Checkbox/Checkbox'
import { PickerValue } from '../types'
import { useClassNames } from '../utils/useClassNames'

interface CheckItemSelection {
  checked: boolean
  event: ChangeEvent<HTMLInputElement>
}

interface DropdownMenuCheckItemProps {
  active: boolean
  focus: boolean
  value: PickerValue
  children: ReactNode
  onSelect: (selection: CheckItemSelection) => void
}

export const DropdownMenuCheckItem = ({
  active,
  focus,
  value,
  children,
  onSelect,
}: DropdownMenuCheckItemProps) => {
  const { withClassPrefix } = useClassNames('check-item')

  return (
    <div role="option" aria-selected={active} aria-disabled={false} data-key={value} tabIndex={-1}>
      <BaseCheckbox
        value={value}
        role="checkbox"
        disabled={false}
        checked={active}
        className={withClassPrefix({ focus })}
        onChange={(_checkboxValue, checked, event) => onSelect({ checked, event })}
      >
        {children}
      </BaseCheckbox>
    </div>
  )
}
